export default {
  OPERACION_UBIGEO: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
